import styled from "@emotion/styled"

const CTAFormFinalText = styled.div`
  font-weight: 500;
  line-height: 32px;
  text-align: center;
  margin-bottom: 100px;
  white-space: pre-wrap;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: 18px;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    font-size: 20px;
  }
`

export default CTAFormFinalText
